function aggregateCheckboxStates() {
    let pdfButtonElem = document.getElementById("pdfButton");
    pdfButtonElem.addEventListener('click', function (event) {
        let checkboxElems = document.getElementsByName("create_pdf");
        let flagList = [];
        checkboxElems.forEach(function (elem) {
            if(elem.checked) {
                flagList.push(elem.value);
            }
        });

        if (flagList.length === 0) {
            alert("チェックボックスを選択してください");
            return 0;
        }

        downloadRequestZip(flagList);
    });
    return 0;
}

function downloadRequestZip(idArray) {
    const baseURL = '/users/generate_zip';
    let params = '';
    idArray.forEach(function (id) {
        params = params + `userIds[]=${encodeURIComponent(id)}&`;
    });
    params = params.slice(0, -1);
    const finalURL = `${baseURL}?${params}`;
    const xhr = new XMLHttpRequest();
    xhr.open('GET', finalURL, true);
    xhr.responseType = 'blob';

    xhr.onload = function () {
        if (xhr.status === 200) {
            const blob = xhr.response;
            const url = window.URL.createObjectURL(blob);
            const now = new Date();
            let fileNameStr = String(now.getFullYear()) + String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0') + "-" + String(now.getHours()).padStart(2, '0') + String(now.getMinutes()).padStart(2, '0');
            const a = document.createElement('a');
            a.href = url;
            a.download = fileNameStr + '.tar';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }
    };

    xhr.send();
    return 0;
}

export function checkboxPdfRequest() {
    // URLのパス部分を取得する
    let pathSegments = window.location.pathname.split("/").filter(function (segment) {
        return !(segment === "");
    });
    // 配列の最後の値を取得する
    let lastIndex = pathSegments.length - 1;

    // 配列の最後の値を取得
    let lastPathName = pathSegments[lastIndex];

    if (lastPathName === "index") {
        aggregateCheckboxStates();
    }
}
